/* This file is autogenerated, see readme.md for instructions */
import SettingsSvgIcon from '@bloomreach/banana-theme/icons/settings.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const SettingsIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <SettingsSvgIcon />
    </Icon>
  );
});

SettingsIcon.displayName = 'SettingsIcon';

export default SettingsIcon;
